import { FC } from 'react';

import Divider from './Divider';

const IssuePanelDivider: FC = () => <Divider style={{ padding: '4px 8px' }} />;

export default IssuePanelDivider;
